export const siteBrand = '泡在我家的辣妹';
export const siteShort = '泡家辣妹';
export const siteSlogan = '同居屋檐下的青春恋爱喜剧，看漫画前先懂剧情';
export const contactEmail = 'hello@paojiagal.example.com';

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '剧情主线', path: '/plot' },
  { label: '人物角色', path: '/characters' },
  { label: '分集剧情', path: '/episodes' },
  { label: '常见问题', path: '/faq' },
  { label: '关于本站', path: '/about' },
];

export const characters = [
  {
    id: 'mio',
    name: '藤野 澪',
    role: '女主角 · 借住男主家的辣妹',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20fashionable%20young%20gal%20with%20long%20wavy%20coral%20pink%20dyed%20hair%20and%20small%20twin%20pigtails%2C%20large%20sparkling%20eyes%2C%20confident%20playful%20smirk%2C%20colorful%20street%20style%20outfit%2C%20soft%20warm%20cream%20background%20with%20light%20coral%20glow%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=600&height=800&seq=char-mio-01&orientation=portrait',
    tags: ['元气', '傲娇', '神秘'],
    intro: '女主角，外表张扬又爱面子，实际上内心柔软。因为某些原因无处可去，被男主角暂时收留，住进同一个屋檐下。',
    detail:
      '藤野澪是校园里公认的辣妹，说话直来直去、穿搭大胆，看似什么都不在乎。可在搬进男主家之后，她笨拙又怕添麻烦的样子逐渐暴露出来。她藏着一段不愿提起的过往，随着相处深入，那些"辣妹外壳"下的温柔和不安才慢慢被男主看见。她与男主的关系从互相看不顺眼，到渐渐习惯彼此的存在。',
  },
  {
    id: 'naoto',
    name: '森下 直人',
    role: '男主角 · 普通高中二年级生',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20plain%20but%20kind%20looking%20high%20school%20boy%20with%20short%20dark%20neat%20hair%2C%20calm%20gentle%20expression%2C%20casual%20school%20uniform%2C%20soft%20warm%20cream%20background%20with%20subtle%20coral%20tint%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=600&height=800&seq=char-naoto-02&orientation=portrait',
    tags: ['温柔', '慢热', '细心'],
    intro: '男主角，成绩中等、性格温和的普通高中生。因为一时心软收留了无处可去的澪，从此生活彻底被"搅乱"。',
    detail:
      '森下直人是那种存在感不强的普通男生，习惯独来独往，生活规律又平静。澪的闯入打破了他按部就班的日子，也让他第一次认真去理解一个人。他嘴上嫌澪麻烦，却总在细节上替她着想。随着两人同居的时间拉长，直人逐渐意识到，自己想要守护的不只是这个借住的"麻烦精"。',
  },
  {
    id: 'mituki',
    name: '春川 美月',
    role: '澪的辣妹闺蜜',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20cheerful%20gal%20friend%20with%20short%20golden%20blonde%20hair%20and%20a%20big%20bright%20smile%2C%20stylish%20casual%20outfit%2C%20warm%20cream%20background%20with%20soft%20amber%20glow%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=600&height=800&seq=char-mituki-03&orientation=portrait',
    tags: ['开朗', '助攻', '爱八卦'],
    intro: '澪最好的闺蜜，性格爽朗、爱凑热闹，是两人关系的重要"催化剂"。',
    detail:
      '春川美月是澪在辣妹小圈子里最要好的朋友，整天笑呵呵，热衷于撮合和"吃瓜"。她是最早察觉到澪对直人态度不一样的人，也是各种脸红心跳场面的最佳观众。虽然嘴上总爱起哄，但关键时候她比谁都懂澪的心。',
  },
  {
    id: 'ayane',
    name: '桐生 绫',
    role: '高年级学姐 · 料理社社长',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20mature%20calm%20senpai%20girl%20with%20long%20straight%20dark%20hair%20and%20gentle%20serene%20smile%2C%20elegant%20casual%20dress%2C%20soft%20warm%20cream%20background%20with%20subtle%20teal%20tint%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=600&height=800&seq=char-ayane-04&orientation=portrait',
    tags: ['成熟', '温柔', '知心'],
    intro: '比直人大一届的学姐，待人温和，常常在澪和直人相处遇到问题时给出恰到好处的建议。',
    detail:
      '桐生绫看起来是标准的优等生，实际上心思细腻、观察力很强。她无意间撞破了两人的同居关系，却选择帮忙保密，还时常以"做料理"为由让他们放松下来。她是这段关系里最清醒的旁观者，也是推动两人直面心意的关键人物。',
  },
  {
    id: 'yui',
    name: '森下 结衣',
    role: '直人的妹妹',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20cute%20younger%20sister%20with%20twin%20tail%20hair%2C%20mischievous%20teasing%20expression%2C%20simple%20casual%20clothes%2C%20soft%20warm%20cream%20background%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=600&height=800&seq=char-yui-05&orientation=portrait',
    tags: ['机灵', '爱捉弄', '小军师'],
    intro: '直人的妹妹，古灵精怪，是家里最早接受澪住进来的人。',
    detail:
      '森下结衣年纪虽小，却鬼点子一堆，最爱拿哥哥和澪的关系开玩笑。她嘴上总是"助攻"得很高调，实际上很珍惜这个让家里热闹起来的"姐姐"。她常常在不经意间说破两人都不敢开口的心事，是推动剧情的重要角色。',
  },
  {
    id: 'azusa',
    name: '千叶 梓',
    role: '学生会长 · 直人青梅竹马',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20composed%20elegant%20student%20council%20president%20girl%20with%20neat%20long%20hair%20and%20slight%20knowing%20smile%2C%20formal%20blazer%20outfit%2C%20soft%20warm%20cream%20background%20with%20subtle%20coral%20glow%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=600&height=800&seq=char-azusa-06&orientation=portrait',
    tags: ['冷静', '青梅竹马', '对手'],
    intro: '与直人从小一起长大的学生会会长，冷静理性，对直人的变化看在眼里。',
    detail:
      '千叶梓是学校里的风云人物，能力强、人缘好，和直人是多年的青梅竹马。她敏锐地察觉到直人因为澪而有了变化，内心的平静也随之被打破。她是感情线上既温柔又充满张力的存在，也让两人的关系更加复杂。',
  },
];

export const plotArcs = [
  {
    id: 'arc1',
    step: '第一幕',
    title: '相遇与同住',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20girl%20and%20boy%20standing%20face%20to%20face%20under%20a%20warm%20street%20lamp%20in%20the%20evening%2C%20coral%20and%20amber%20night%20tones%2C%20clean%20flat%20manga%20art%2C%20slightly%20awkward%20but%20gentle%20mood%2C%20high%20detail&width=900&height=600&seq=arc-meet-01&orientation=landscape',
    summary:
      '放学后的车站前，直人偶遇无处可去的辣妹澪。看她淋着雨、一副倔强又狼狈的样子，直人一时心软，把她带回了自己家暂住。',
    points: ['车站前的一场偶遇', '无处可去的辣妹', '一时心软的收留', '同居生活就此开始'],
  },
  {
    id: 'arc2',
    step: '第二幕',
    title: '磨合与了解',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20two%20teens%20cooking%20together%20in%20a%20cozy%20kitchen%2C%20warm%20cream%20and%20coral%20tones%2C%20soft%20domestic%20atmosphere%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=900&height=600&seq=arc-melt-02&orientation=landscape',
    summary:
      '同一屋檐下的日子鸡飞狗跳，生活习惯完全不同的两人从互相嫌弃，到慢慢学会体谅对方，感情在琐碎日常里悄悄萌芽。',
    points: ['生活习惯大冲突', '互相嘴硬又互相照顾', '秘密的小约定', '关系开始变得不一样'],
  },
  {
    id: 'arc3',
    step: '第三幕',
    title: '各自的秘密',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20girl%20sitting%20alone%20by%20a%20window%20at%20dusk%2C%20reflective%20melancholic%20mood%2C%20coral%20and%20deep%20orange%20twilight%20tones%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=900&height=600&seq=arc-secret-03&orientation=landscape',
    summary:
      '澪不愿提起的过往浮出水面，她住进直人家的真正原因也逐渐揭开。直人选择不去追问，而是用行动站在她身边。',
    points: ['澪隐藏的家庭真相', '直人的默默守护', '来自过去的阴影', '两人第一次说真心话'],
  },
  {
    id: 'arc4',
    step: '第四幕',
    title: '心动与告白',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20two%20blushing%20teenagers%20close%20together%20under%20soft%20warm%20evening%20light%2C%20romantic%20coral%20and%20pink%20tones%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=900&height=600&seq=arc-heart-04&orientation=landscape',
    summary:
      '校园生活与同居日常交织，青梅竹马、闺蜜、学姐轮番登场，把两人之间暧昧的气氛推到顶点，一场笨拙又真挚的告白终于发生。',
    points: ['感情线的多方交汇', '一场误会引爆心意', '笨拙又真挚的告白', '关系的全新开始'],
  },
  {
    id: 'arc5',
    step: '第五幕',
    title: '家庭与未来',
    image:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20small%20family%20gathering%20in%20a%20warm%20living%20room%2C%20everyone%20laughing%20together%2C%20coral%20amber%20and%20cream%20warm%20tones%2C%20cozy%20hopeful%20mood%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=900&height=600&seq=arc-future-05&orientation=landscape',
    summary:
      '面对家庭与未来的选择，澪和直人学着并肩前行。借住终有期限，但"家"的定义已经悄悄改变。',
    points: ['来自家人的考验', '直面未来的选择', '"家"的定义被重写', '朝着同一个方向前进'],
  },
];

export const highlights = [
  {
    icon: 'ri-heart-3-line',
    title: '元气辣妹 × 温柔宅男',
    desc: '性格截然相反的两人被迫同住，反差感拉满，笑点与心动齐飞。',
  },
  {
    icon: 'ri-home-4-line',
    title: '同居日常的烟火气',
    desc: '从早餐、洗衣服到深夜谈心，细碎日常里藏着真实动人的温度。',
  },
  {
    icon: 'ri-lock-line',
    title: '层层揭开的身世线',
    desc: '女主不愿提起的过去，像洋葱一样层层剥开，悬念与温情并存。',
  },
  {
    icon: 'ri-group-line',
    title: '鲜活讨喜的配角群',
    desc: '闺蜜、学姐、妹妹、青梅竹马轮番登场，让感情线更加立体。',
  },
  {
    icon: 'ri-sun-line',
    title: '治愈温暖的成长',
    desc: '两个不够完美的人，在同住中互相治愈、一起变得更好。',
  },
  {
    icon: 'ri-sparkling-2-line',
    title: '甜而不腻的心动',
    desc: '慢节奏、重细节的情感推进，糖分刚刚好，不狗血不拖沓。',
  },
];

export const episodes = [
  {
    id: 1,
    title: '淋雨的辣妹',
    season: '第一季',
    tag: '相遇',
    summary:
      '放学的车站前下起大雨，直人看到无处可去、浑身湿透的澪，鬼使神差地把伞递了过去。',
  },
  {
    id: 2,
    title: '借住的第一个夜晚',
    season: '第一季',
    tag: '同居',
    summary:
      '澪住进直人家的第一个夜晚，两人手忙脚乱地划分"地盘"，还因为被子的归属闹了笑话。',
  },
  {
    id: 3,
    title: '早餐的战争',
    season: '第一季',
    tag: '日常',
    summary:
      '面对"只会煮泡面"的澪和"只会煎蛋"的直人，两人在厨房里展开了一场艰难的早餐对决。',
  },
  {
    id: 4,
    title: '学校里的传闻',
    season: '第一季',
    tag: '校园',
    summary:
      '澪和直人的同居被同学撞见，校园里开始流传各种离谱的传闻，美月趁机疯狂"拱火"。',
  },
  {
    id: 5,
    title: '青梅竹马的出现',
    season: '第一季',
    tag: '波澜',
    summary:
      '学生会长千叶梓出现，她与直人熟络的关系让澪第一次感到莫名的烦躁。',
  },
  {
    id: 6,
    title: '藏起来的照片',
    season: '第一季',
    tag: '秘密',
    summary:
      '澪藏在行李里的旧照片被不小心翻出，她慌乱的反应让直人察觉到她不愿提起的过去。',
  },
  {
    id: 7,
    title: '深夜的真心话',
    season: '第一季',
    tag: '交心',
    summary:
      '一夜失眠的两人在客厅坦白心事，澪第一次向直人透露出自己离家出走的原因。',
  },
  {
    id: 8,
    title: '学姐的料理课',
    season: '第二季',
    tag: '日常',
    summary:
      '桐生学姐以"学做饭"为由撮合两人，在一顿意外的晚餐里，气氛微妙地升温。',
  },
  {
    id: 9,
    title: '打工与误解',
    season: '第二季',
    tag: '波澜',
    summary:
      '澪偷偷去打工想攒钱还直人的人情，却被直人误以为要搬走，引发一场别扭的误会。',
  },
  {
    id: 10,
    title: '暴雨里的守护',
    season: '第二季',
    tag: '高光',
    summary:
      '台风夜澪的家人找上门来，直人挡在她身前说出的那番话，让两人都愣住了。',
  },
  {
    id: 11,
    title: '毕业季的告白',
    season: '第二季',
    tag: '告白',
    summary:
      '在烟火大会的夜空下，澪终于鼓起勇气，说出一句藏了很久的话。',
  },
  {
    id: 12,
    title: '家的定义',
    season: '第二季',
    tag: '新章',
    summary:
      '借住的期限将近，两人重新审视"家"的意义，故事迎来新的篇章。',
  },
];

export const faqs = [
  {
    q: '《泡在我家的辣妹》漫画剧情到底讲了什么？',
    a: '故事围绕普通高中生直人与无处可去的辣妹澪展开。直人一时心软将澪收留在家，两人在同一屋檐下从互相嫌弃到逐渐了解，在鸡飞狗跳的日常里碰撞出温暖与心动，同时澪不愿提起的过去也一点点被揭开。',
  },
  {
    q: '这部漫画是什么题材？',
    a: '这是一部校园恋爱喜剧，以"辣妹与温柔宅男的同居"为切入点，融合了日常搞笑、暖心治愈和循序渐进的感情线，整体氛围轻松但又不乏细腻的情感刻画。',
  },
  {
    q: '主要角色有哪些？',
    a: '主要角色包括女主角藤野澪、男主角森下直人，以及澪的闺蜜春川美月、学姐桐生绫、直人的妹妹森下结衣、青梅竹马千叶梓等，配角群个性鲜明，对主线推进作用很大。',
  },
  {
    q: '澪为什么会住在直人家？',
    a: '澪因为家庭原因暂时无处可去，又不想向周围人示弱，正好被路过的直人收留。她住进直人家既是为了解决眼前的住处问题，也藏着一段暂时不愿向任何人提起的过往。',
  },
  {
    q: '作品的感情线进展快吗？',
    a: '感情线属于慢热类型，强调日常相处中的细节积累，糖分适中、不刻意。两人关系从磨合到心动再到告白层层递进，中途有青梅竹马、误会等波折，但整体走向甜而不腻。',
  },
  {
    q: '漫画目前更新到哪里了？',
    a: '剧情节数会随作品连载进度持续更新，本站会同步整理最新分集剧情，建议关注本站剧情主线与分集剧情页面获取最新内容。',
  },
  {
    q: '这部漫画适合哪些读者？',
    a: '适合喜欢校园恋爱喜剧、同居题材以及"反差萌"设定的读者。如果你偏爱温柔治愈、重视细节情感的叙事节奏，这部作品会相当对味。',
  },
  {
    q: '从哪里可以读到这部漫画？',
    a: '本站仅提供剧情与设定介绍，不提供漫画阅读资源。具体阅读渠道请以作品官方发布平台为准，支持正版、快乐追漫。',
  },
];

export const testimonials = [
  {
    name: '追漫的小K',
    avatarText: 'K',
    role: '恋爱番爱好者',
    content:
      '被女主的人设圈粉了！辣妹外壳下藏着那么多小细节，和男主互怼又互相照顾的样子太好磕，一口气补完还意犹未尽。',
  },
  {
    name: '阿饼不吃辣',
    avatarText: '饼',
    role: '日常系读者',
    content:
      '最喜欢它不靠狗血推动剧情，同居日常里的每一顿饭、每一次深夜谈心都很戳人，是那种看完会让人心里暖暖的作品。',
  },
  {
    name: '柠檬汽水',
    avatarText: '柠',
    role: '漫画剧情考据党',
    content:
      '把剧情主线理得很清楚，分集要点也标注得明明白白，追更前先看这里，再也不用担心跟不上节奏。',
  },
];